<template>
  <div class="card mb-5 mb-xxl-8" v-show="!isReady">
    <!--begin::Body-->
    <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <!--begin::Card header-->
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('store.output.title') }}</h3>
        </div>
        <div class="card-toolbar">
          <router-link :to="{name: 'store-output-create', params: {id: $route.params.id}}" class="btn btn-sm btn-primary m-2">{{ $t('store.output.add') }}</router-link>
        </div>

      </div>
      <div class="card-body">
        <!--begin::Layout-->
        <div class="row">
          <!--begin::Table-->
          <table class="table align-middle table-row-bordered fs-6 gy-3 "  id="kt_datatable_output">
            <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-100px">{{ $t('store.output.numero')}}</th>
              <th class="min-w-100px">{{ $t('store.output.date')}}</th>
              <th class="min-w-100px">{{ $t('product.status')}}</th>
              <th class="min-w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>

          </table>
          <!--end::Table-->
        </div>
        <!--end::Layout-->
      </div>
      <!--end::Card body-->
    </div>
    <!--end::Body-->
  </div>
  <div class="container-xxl" v-show="isReady">
    <Loader />
  </div>
</template>

<script>
import {BASE_URL} from '@/services/api'
import {mapActions} from 'vuex'
import Loader from "@/components/Loader.vue";
export default {
  name : "OutputView",
  components: { Loader },
  data() {
    return {
      formDataDelete : {
        id_output: null,
        id : this.$route.params.id
      },
      isReady: false
    }
  },
  async mounted(){
    this.isReady = true

    $(document).on('click', '#kt_datatable_output .delete_btn', (e) => {
      this.formDataDelete.id_output = e.target.getAttribute('data-id')
      Swal.fire({
        text: i18n.global.t('store.delete_output'),
        icon: "error",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('store.delete'),
        cancelButtonText: i18n.global.t('store.cancel'),
        customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if(result.isConfirmed){
          this.removeData();
        }
      })
    })
    
    $(document).on('click', '#kt_datatable_output .eye_btn', (e) => {
      this.formDataDelete.id_output = e.target.getAttribute('data-id')

      this.$router.push({name: 'store-output-content', params: {id: this.$route.params.id, id_content: this.formDataDelete.id_output}})
    })

    this.fetchDatas();

    this.isReady = false
  },
    methods : {
      ...mapActions('store', ['removeOutputStore']),
      async removeData(){
        let response = {}
        try{
          response = await this.removeOutputStore(this.formDataDelete)
          window.toastr['success'](i18n.global.t('notification.store.entrie_delete'))
          this.table.ajax.reload()
          this.formDataDelete.id_output = ""
        }catch(err){

        }
      },
    fetchDatas(){
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_output").DataTable({
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'desc']],
        ajax: {
          url: BASE_URL+"/get/stores/"+this.$route.params.id+"/output/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data:  function ( d ) {

          }
        },
        columns: [{ data: "numero" },{ data: "date" },{data : 'status'}, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -4,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="amountRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="amountRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'"  class="typeRow'+ l.row +'">' + t + "</span>";
            },
          },

          {
            width: "10%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {

              let render=""
              render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-numero="'+ e.numero +'" class="btn btn-sm btn-clean btn-icon eye_btn"><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-numero="'+ e.numero +'" data-date="'+ e.date +'" class="fas fa-eye"></i></a>'
              // Suppression d'un bon retirée : la route API n'existe plus (bons non supprimables)
              return render

            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

  }
}
</script>

<style scoped>

</style>
